import { primitive } from 'styles/constants';

export default {
  closeButtonBoxShadow: 'none',
  modalContentBackground: primitive.$mayoEggWhite,
  modalWrapperBackground: primitive.$mayoEggWhite,
};
